import '../assets/css/App.css';
import Home from '../components/screen/home/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Contact from '../components/screen/contact/Contact';
import Footer from '../components/util/Footer';
import Header from '../components/util/Header';
import Service from '../components/screen/home/Service';
import ScrollToTop from '../components/util/ScrollToTop';
import ProfileDetails from '../components/screen/details/ProfileDetails';
import Login from '../components/screen/login/Login';
import ForgetPassword from '../components/screen/login/ForgetPassword';
import Signup from '../components/screen/signup/Signup';
import Account from '../components/screen/account/Account';
import { useEffect, useState } from 'react';
import { auth, findUser,findMess,findTeacher } from '../firebase';
import {AuthContext} from '../context/AuthContext';
import EditUser from '../components/screen/account/EditUser';
import {store} from '../context/store';
import TutorService from '../components/screen/service/tutor/TutorService';
import MessService from '../components/screen/service/mess/MessService';
import MessDetails from '../components/screen/details/MessDetails';

function App() {
  const [user,setUser]=useState(store.user);
  const [teacher,setTeacher]=useState(store.teacher);
  const [mess,setMess]=useState(store.mess);
  const [userList,setUserList]=useState([]);
  const [emails, setEmails] = useState([]);

  useEffect(()=>{
    const unsubscribe=auth.onAuthStateChanged(userAuth=>{
      setUser(store.user);
      setMess(store.mess);
      setTeacher(store.teacher);

      if(userAuth && userAuth.emailVerified){
        setUser(pre=>({...pre,id:userAuth.uid,
           email:userAuth.email?userAuth.email:"",
           phone:userAuth.phoneNumber?userAuth.phoneNumber:""}));
        findUser(userAuth.uid).then(res=>{
          if(res){
            setUser(pre=>({...pre,...res}));
            if(res.profile?.includes('Teacher')){
              findTeacher(userAuth.uid).then(res=>setTeacher(res));
            }
            if(res.profile?.includes('Mess')){
              findMess(userAuth.uid).then(res=>setMess(res));
            }
          }
        })
      }else{
        setUser(null);
      }
    })
    return unsubscribe;
  },[])

  return (
    <AuthContext.Provider value={{user,teacher,mess,userList,emails,setEmails,setUser,setTeacher,setMess,setUserList}}>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/services" element={<Service />}></Route>
          <Route path="/tutor" element={<TutorService />}></Route>
          <Route path="/mess" element={<MessService />}></Route>
          <Route path="/profile/:id" element={<ProfileDetails />}></Route>
          <Route path="/mess/:mid/:uid" element={<MessDetails />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/forgetPassword" element={<ForgetPassword />}></Route>
          <Route path="/signup" element={<Signup />}></Route>
          <Route path="/account" element={user?<Account />:<Login />}></Route>
          <Route path="/editUser" element={<EditUser />}></Route>
          <Route path="/account" element={<Account />}></Route>
          <Route path="/" element={<Home />}></Route>
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
    </AuthContext.Provider>
  );
}

export default App;
